import { useContext } from 'react';
import { SchemaExpressionScopeContext } from '../shared/context';
export var useExpressionScope = function () { return useContext(SchemaExpressionScopeContext); };
//# sourceMappingURL=useExpressionScope.js.map